import { createContext } from 'react'
import { Region } from './shared/utils/region'

export const HermesSdkContext = createContext<
  | {
      tenant: Region
      accessToken?: string
    }
  | undefined
>(undefined)
